import { EcommerceAPIApi as EcommerceApi } from '@parkingbase/ecommerce-api-test';
import { BaseApiService } from './baseApi.service';

export class DamageClaimService extends BaseApiService {
  protected damageClaimApi: EcommerceApi;
  constructor() {
    super();
    this.damageClaimApi = new EcommerceApi(this.apiConfig, undefined, this.apiClient);
  }

  async getDamageClaimDetails(requestId: string, company?: string) {
    const response = await this.damageClaimApi.getDamageClaimDetails(requestId, company, {
      skipAuth: true,
    } as any);
    return response.data;
  }

  async submitDamageClaim(
    companyId: string,
    requestId: string,
    damageClaimRequest: string,
    files: File[]
  ) {
    const response = await this.damageClaimApi.submitDamageClaim(
      companyId,
      requestId,
      damageClaimRequest,
      files,
      { skipAuth: true } as any
    );
    return response.data;
  }
}
